import Cookies from 'js-cookie';

export default class CompareProducts
{
  constructor()
  {
    this.setVars();
    
    window.addEventListener('compare_product_reinit', () => {
      this.setVars();
    })
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-compare-product',
    };
    
    this.compare = document.querySelector(`[${this.settings.main}]`);
    if (!this.compare) return;
    this.products = [];
    
    this.getCookie();
    
    this.setEvents();
  }
  
  setEvents()
  {
    this.compare.addEventListener('click', (e) => {
      const product_id = e.target.getAttribute(this.settings.main);
      this.manageProducts(product_id);
    })
  }
  
  manageProducts(product_id) {
    if (this.products.includes(product_id)) {
      this.openPopupAdded();
    } else {
      this.products.push(product_id);
      this.openPopupAdd();
    }
    
    this.setCookie();
  }
  
  openPopupAdd() {
    const wishlistCounter = document.querySelector('[data-counter-wishlist]');
  
    if (!wishlistCounter.hasClass('active') && this.products.length > 0) {
      wishlistCounter.addClass('active')
    }
  
    wishlistCounter.setAttribute('data-counter-wishlist', this.products.length);
    const popup = document.querySelector('[data-product-compare-add]');
    popup.addClass('active');
    
    setTimeout(() => {
      popup.removeClass('active');
    }, 3000);
  }
  
  openPopupAdded() {
    const popup = document.querySelector('[data-product-compare-added]');
    popup.addClass('active');
    
    setTimeout(() => {
      popup.removeClass('active');
    }, 3000);
  }
  
  getCookie() {
    const cookie = Cookies.get('woo_compare_product');
    if (cookie) {
      this.products = cookie.split(' ').filter((el) => { return el != ''; });
    }
  }
  
  setCookie() {
    if (!this.products.length) {
      Cookies.set('woo_compare_product', '');
    } else {
      Cookies.set('woo_compare_product', this.products.join(' '))
    }
  }
}
